import BaseVitalCard, { VitalCardConfig } from "../../../Common/BaseVitalCard";
import { WellnessScoreStatus } from "../../../Common/types";

export interface HeartRateCardProps {
  metricValue: string;
  status: WellnessScoreStatus;
  lastUpdated?: string;
  onManualEntryClick?: () => void;
}

const config: VitalCardConfig = {
  translationPrefix: "HeartRate",
  analyticsSource: "Health Score - heart rate",
  manualEntryRoute: "/home/health-score/heart-rate-manual-entry",
};

export default function HeartRateCard(props: HeartRateCardProps): JSX.Element {
  return <BaseVitalCard {...props} config={config} />;
}
